"use strict";
document.addEventListener('DOMContentLoaded', () => {
    const maintenanceButton = document.querySelector('.application-maintenance-message button');
    if (maintenanceButton) {
        maintenanceButton.addEventListener('click', () => {
            const applicationMaintenanceMessage = document.querySelector('.application-maintenance-message');
            applicationMaintenanceMessage.classList.add('application-maintenance--close');
            window.setTimeout(() => {
                document.querySelector('.application-maintenance-message').remove();
            }, 1000);
        });
    }
});
